export default __webpack_public_path__ + "img/feWYjxLn.a21a1a44.svg";